import { applyMiddleware, compose } from 'redux'
import thunkMiddleware from 'redux-thunk'

const prepare = (middleware, extra) => {
  return applyMiddleware(thunkMiddleware.withExtraArgument(extra), middleware)
}

export default prepare
